import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=90e49a3a&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/users/account-setting.css?vue&type=style&index=0&id=90e49a3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e49a3a",
  null
  
)

export default component.exports